__webpack_require__.p = "/snap-account-abstraction-keyring/0.5.0/";